import React from "react";
import Headers from "../../../components/Headers";
import { Input, Row, Col, Button, Table, DatePicker, Modal } from "antd";
import NProgress from "nprogress";
import { fetchSpdList, fetchSpdRecord } from "../../../api/grantRecord";
import "./index.scss";
const { RangePicker } = DatePicker;
const { Column } = Table;
const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/replenishment/bankRecord", name: "派样记录" },
];

class BankRecord extends React.Component {
  state = {
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      beginTime: "",
      endTime: "",
      nickName: "",
      mobilePhone: "",
    },
    total: 0,
    list: [],
    recordList: [],
    recordVisible: false,
  };
  handleChange = (e) => {
    this.setState({
      listQuery: {
        ...this.state.listQuery,
        [e.target.name]: e.target.value,
      },
    });
  };
  handleExport = () => {
    let info = this.state.listQuery;
    let str = "";
    Object.keys(info).forEach((item) => {
      str = str + item + "=" + info[item] + "&";
    });
    str =
      str +
      "accessToken=" +
      JSON.parse(sessionStorage.getItem("loginInfo")).accessToken;
    window.open(process.env.REACT_APP_API_PREFIX + "spd/list/export?" + str);
  };
  componentDidMount() {
    NProgress.start();
    this.getList();
    NProgress.done();
  }
  handleSearch = () => {
    this.setState(
      {
        listQuery: {
          ...this.state.listQuery,
          pageNum: 1,
        },
      },
      () => {
        this.getList();
      }
    );
  };
  getList = () => {
    fetchSpdList(this.state.listQuery).then((res) => {
      if (res.success) {
        if (res.data.list) {
          this.setState({
            list: res.data.list,
            total: res.data.total,
          });
        }
      }
    });
  };
  dateChange = (date, dateString) => {
    this.setState({
      listQuery: {
        ...this.state.listQuery,
        beginTime: dateString[0],
        endTime: dateString[1],
      },
    });
  };
  viewDetails = (record) => {
    fetchSpdRecord({ userId: record.userId }).then((res) => {
      if (res.success) {
        this.setState({
          recordList: res.data,
          recordVisible: true,
        });
      }
    });
  };
  handleCancel = () => {
    this.setState({
      recordVisible: false,
    });
  };
  renderFrom = (text, record) => {
    switch (record.from) {
      case "HOME":
        return "首页";
        break;
      case "TASK":
        return "任务中心";
        break;
      default:
        break;
    }
  };
  render() {
    const { listQuery, list, total, recordList, recordVisible } = this.state;
    return (
      <div className="container">
        <Modal
          className="spdModal"
          width={600}
          title="访问记录"
          footer={null}
          visible={recordVisible}
          onCancel={this.handleCancel}
        >
          <Table pagination={false} dataSource={recordList} rowKey="createTime">
            <Column
              title="ID"
              render={(record, value, index) => <span>{index + 1}</span>}
            />
            <Column title="时间" dataIndex="createTime" key="createTime" />
            <Column
              title="渠道"
              dataIndex="from"
              key="from"
              render={this.renderFrom}
            />
          </Table>
        </Modal>
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="bank_container">
          <Row style={{ marginBottom: 8 }} className="card_container">
            <Col span={22}>
              <RangePicker
                className="marginR"
                onChange={this.dateChange}
                style={{ width: 250 }}
              />
              <Input
                allowClear
                name="nickName"
                onChange={this.handleChange}
                className="marginR"
                style={{ width: 160 }}
                value={listQuery.nickName}
                placeholder="用户昵称"
              ></Input>
              <Input
                allowClear
                name="mobilePhone"
                onChange={this.handleChange}
                className="marginR"
                style={{ width: 160 }}
                value={listQuery.mobilePhone}
                placeholder="手机号码"
              ></Input>

              <Button onClick={this.handleSearch} type="primary">
                搜索
              </Button>
            </Col>
            <Col span={2}>
              <Button className="fr" onClick={this.handleExport} type="primary">
                导出
              </Button>
            </Col>
          </Row>
          <div className="card_container">
            <Table
              dataSource={list}
              rowKey="userId"
              pagination={{
                showTotal: () => `共${total}条`,
                total: total,
                current: listQuery.pageNum,
                pageSize: listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                onChange: (page, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageNum: page },
                    },
                    () => this.getList()
                  );
                },
                onShowSizeChange: (current, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageSize, pageNum: 1 },
                    },
                    () => this.getList()
                  );
                },
              }}
            >
              <Column title="时间" dataIndex="createTime" key="createTime" />
              <Column title="昵称" dataIndex="nickName" key="nickName" />
              <Column
                title="手机号码"
                dataIndex="mobilePhone"
                key="mobilePhone"
              />
              <Column title="访问次数" dataIndex="num" key="num" />
              <Column
                width="100px"
                title="访问记录"
                render={(text, record) => {
                  return (
                    <a onClick={() => this.viewDetails(record)}>查看记录</a>
                  );
                }}
              />
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default BankRecord;
